<template>
  <el-row>
    <el-alert
        title="消息提示的文案"
        type="info"
        :closable="false"
        description="审核通过，将修改线索为“无效线索”且修改收车状态为“放弃收车”且自动补偿线索+2次；审核驳回，不会改变线索状态、收车状态，也不支持客户继续申诉，请谨慎操作！"
        show-icon>
    </el-alert>
    <el-form :model="authClueCarRecordForm"
             ref="authClueCarRecordRef"
             :rules="rules"
             @onSelectInfo="onSelectInfo"
             addAction="clueCar/authAppealStatus.action"
             editAction="clueCar/authAppealStatus.action"
             selectAction=""
             label-width="150px"
             style="width:50%"
             v-form>
      <el-form-item label="审核状态">
        <el-radio-group v-model="authClueCarRecordForm.status">
          <el-radio :label="3">申诉通过</el-radio>
          <el-radio :label="4">申诉驳回</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审核备注" prop="appealHandleRemark">
          <el-input type="textarea" v-model="authClueCarRecordForm.appealHandleRemark"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
      <el-form-item label="发送短息">
        <el-switch v-model="authClueCarRecordForm.msgSwitch" :inactive-value="2" :active-value="1"></el-switch>
      </el-form-item>
      <el-form-item v-if="authClueCarRecordForm.msgSwitch==1">
              <p style="color:red;" v-if="authClueCarRecordForm.status==3">
              短信推送： 【车小花二手车内网】处理结果:申诉通过，备注：{{authClueCarRecordForm.appealHandleRemark}},请关注“车小花二手车”公众号，进入内网查看
                。</p>
        <p style="color:red;" v-if="authClueCarRecordForm.status==4">
              短信推送： 【车小花二手车内网】处理结果:申诉驳回，备注：{{authClueCarRecordForm.appealHandleRemark}},请关注“车小花二手车”公众号，进入内网查看。
        </p>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'

export default {
  name: 'authClueCarRecord',
  extends: BasicPager,
  components: {},
  data: function () {
    return {
      rules: {
        appealHandleRemark: [
          { required: true, message: '备注不能为空', trigger: 'blur' }
        ]
      },
      authClueCarRecordForm: {
        id: null,
        appealHandleRemark: null,
        msgSwitch: 1,
        status: null
      }
    }
  },
  created () {
    this.authClueCarRecordForm.id = this.$route.query.id
  },
  methods: {
    onFilterParams: function (params) {
    },
    onSelectInfo: function (dataInfo) {
    }
  },
  filters: {}

}
</script>

<style scoped>

</style>
